import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';

export const selectShipment = (state) => get(state, 'shipment') || emptyObject;
